<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加维修订单"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="maintainOrder" :label-width="80" >
      <FormItem prop="businessUserId" label="问题车辆">
        <Select placeholder="请选择问题车辆"
                v-model="maintainOrder.vehicleInfoId"
                filterable
                remote
                :remote-method="searchVehicleInfo"
                :loading="searchVehicleInfoLoading"
                class="field" style="width: 80%;"
                @on-select="onselect"
                clearable>
          <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="option.id">{{option.registrationNum==null?option.vin:option.registrationNum}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="positioningDeviceInfo" label="问题设备">
        <Select v-model="maintainOrder.positioningDeviceInfos" multiple style="width: 220px;">
          <Option v-for="item in positioningDeviceInfosTypeOptions" :value="item.positioningDeviceModel.name" :key="item.terminalNum">
            {{item.terminalNum + '(' + item.positioningDeviceModel.name + ')'}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="bookingDatetime" label="预约时间">
        <DatePicker type="date" v-model="maintainOrder.bookingDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="question" label="订单类型">
        <Select v-model="maintainOrder.maintainType">
          <Option v-for="item in maintainTypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="question" label="问题描述">
        <Input class="field" v-model="maintainOrder.question" type="textarea">
        </Input>
      </FormItem>
      <FormItem prop="remark" label="备注">
          <Input class="field" v-model="maintainOrder.remark" type="textarea">
          </Input>
      </FormItem>
      <FormItem prop="maintainerId" label="维修员">
        <Select class="field" v-model="maintainOrder.maintainerId">
          <Option v-for="item in maintainers" :value="item.id" :key="item.realName===null?item.name:item.realName">{{item.realName===null?item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addmaintainordermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchVehicleInfoLoading: false,
      searchVehicleInfoList: [],

      maintainers: [],

      maintainOrder: {
        vehicleInfoId: null,
        bookingDatetime: null,
        maintainType: 0,
        question: null,
        remark: null,
        maintainerId: null,
        positioningDeviceInfos:null
      },

      positioningDeviceInfosTypeOptions:[],

      //维修订单类型
      maintainTypeOptions: [
        {name: '维修', value: 0},
        {name: '返修', value: 1},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    searchVehicleInfo (input) {
      this.searchVehicleInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoList = []
        this.searchVehicleInfoLoading = false
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoList = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
          this.searchVehicleInfoLoading = false
        }).catch(err => {
          this.searchVehicleInfoLoading = false
        })
      }
    },
    /**
     * 选择车辆
     */
    onselect(e){
      console.log(e)
      store.dispatch('VehicleInfoServ_GetDetail', {
        params: { id: e.value },
        urlparams: null
      }).then(res => {
        console.log(res)
        this.positioningDeviceInfosTypeOptions = store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos
      }).catch(err => {
        console.log(err)
      })
    },
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认添加维修订单</p>',
        onOk: () => {
          store.dispatch('MaintainOrderServ_AddObj', { params: this.maintainOrder }).then(() => {
            this.$Message.success('添加维修订单成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.maintainOrder.vehicleInfoId = null
        this.maintainOrder.bookingDatetime = null
        this.maintainOrder.maintainType = 0
        this.maintainOrder.question = null
        this.maintainOrder.remark = null
        this.positioningDeviceInfosTypeOptions = []

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8] }
        }).then(() => {
          this.maintainers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
